//export const API_URL="http://st-api.stfondos.com:35006/api/"
export const API_URL="https://apifondos.consultatioasset.com.ar/api/"
